import {
  AppBar,
  Box,
  Container,
  Grid,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  Toolbar,
} from "@mui/material";
import { DataGrid, GridColDef, GridFilterModel } from "@mui/x-data-grid";
import { useAppContext } from "../../../libs/app-core/AppContext";
import { Toast } from "../../../libs/app-core/Toast";
import { useGridApiRef } from "../../../libs/data-grid-view/useGridApiRef";
import {
  linear_content_style,
  linear_h,
  linear_item,
  linear_v,
} from "../../../libs/linear-layout/LinearLayout";
import Title from "../../../libs/rhf-mui/ui/Title";
import { ROUTE_project_editor, ROUTE_project_merge } from "../../Routes";
import Blocker from "../../components/Blocker";
import { Project } from "../../dao/Project";
import { ProjectDAO, useProjectList } from "../../dao/ProjectDAO";
import { R } from "../../R";
import TabPage from "../../components/TabPage";
import {
  DGV_LOCAL_TEXT,
  UIHelper,
  sx_icon_button,
} from "../../components/UIHelper";
import AppMenuButton from "../../components/AppMenuButton";
import { useEffect, useState } from "react";
import UcDgvCustomToolbar from "../../components/UcDgvCustomToolbar";
import UcDgvCustomPagination from "../../components/UcDgvCustomPagination";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MoreIcon from "@mui/icons-material/MoreVert";
import { InputDialog } from "../../../libs/app-core/dialogs/InputDialog";
import { SelectDialog } from "../../../libs/app-core/dialogs/SelectDialog";
import DateHelper from "../../heplers/DateHelper";

type Props = {};

const FrmProjectList = (props: Props) => {
  const ctx = useAppContext();
  const columns: GridColDef[] = [
    {
      field: "rec_dt",
      headerName: "健檢開始日",
      width: 150,
      valueGetter: (params) => {
        return (params.row as Project).get_RecDT_str();
      },
    },
    { field: "cid", headerName: "cid", width: 150 },
    { field: "project_code", headerName: "場次編號", width: 150 },
    { field: "project_name", headerName: "場次名稱", width: 320 },
    { field: "cust_name", headerName: "客戶名稱", width: 320 },
    {
      field: "quest_start",
      headerName: "開放日期",
      width: 150,
      valueGetter: (params) => {
        return (params.row as Project).get_QuestStart_str();
      },
    },
    {
      field: "quest_end",
      headerName: "截止日期",
      width: 150,
      valueGetter: (params) => {
        return (params.row as Project).get_QuestEnd_str();
      },
    },

    { field: "account_rule", headerName: "帳號類別", width: 150 },
    { field: "password_rule", headerName: "密碼類別", width: 150 },
    { field: "end_dt", headerName: "結案日期", width: 150 },
  ];

  const grid_api = useGridApiRef(columns);
  const { _ProjectList } = useProjectList(true);
  const MAX_WIDTH = "lg";
  const [AppBarTabIndex] = useState("Tab1");
  const [MenuPosition, set_MenuPosition] = useState<any>(null);
  const [MenuName, set_MenuName] = useState<any>(null);
  const [filterModel, setFilterModel] = useState<GridFilterModel>({
    items: [],
  });

  useEffect(() => {
    // 清除 project_filterModel
    localStorage.removeItem("project_filterModel");
    // 清除 project_guid
    localStorage.removeItem("project_guid");

    // 讀取 FilterModel
    const filterModel = localStorage.getItem("project_list_filterModel");
    if (filterModel) {
      setFilterModel(JSON.parse(filterModel));
    }
  }, []);

  const handleFilterChange = (model: GridFilterModel) => {
    localStorage.setItem("project_list_filterModel", JSON.stringify(model));
    setFilterModel(model);
  };

  const OnMenuOpen = (event: React.MouseEvent, menu_strip_name: string) => {
    if (MenuPosition) {
      return;
    }
    event.preventDefault();
    set_MenuName(menu_strip_name); // 標記要開啟的 Menu

    const rect = event.currentTarget.getBoundingClientRect();
    set_MenuPosition({ top: rect.top + rect.height, left: rect.left }); // 左下角
  };

  if (_ProjectList === undefined) {
    return <Blocker />;
  }

  function render_ProjectList() {
    return (
      <Box style={linear_content_style} bgcolor={R.color.paper}>
        <Container sx={{ height: "100%", pb: 3, pt: 2 }} maxWidth={false}>
          <Grid {...linear_v}>
            <Grid {...linear_item} flex={1}>
              {render_DataGrid()}
            </Grid>
          </Grid>
        </Container>
      </Box>
    );
  }

  return (
    <Box style={linear_content_style}>
      {/* 外框架 */}
      <Grid {...linear_h}>
        <Grid {...linear_item} width={0} bgcolor="#FFCCFF">
          {/* 左側主檔 Master */}
          <Box bgcolor="#CCCCFF"></Box>
        </Grid>
        <Grid {...linear_item} flex={1} bgcolor="">
          {/* 中間列表 Details */}
          {render_Detail()}
        </Grid>
      </Grid>
    </Box>
  );

  function render_Detail() {
    return (
      <>
        <Grid {...linear_v}>
          <Grid {...linear_item}>{render_AppBar()}</Grid>
          <Grid {...linear_item} flex={1}>
            <Box style={linear_content_style} sx={{}}>
              <TabPage
                tab_key={"Tab1"}
                curr_tab={AppBarTabIndex}
                sx={{ height: "100%", overflow: "hidden" }}
              >
                <Box sx={{ height: "100%" }}>{render_ProjectList()}</Box>
              </TabPage>

              {/* Tab範例: Master列表型 - 填滿畫面 (yellow)*/}
              <TabPage
                tab_key={"Tab2"}
                curr_tab={AppBarTabIndex}
                sx={{ bgcolor: "#FFFFCC", height: "100%", overflow: "hidden" }}
              >
                <Container
                  maxWidth={MAX_WIDTH}
                  sx={{ height: "100%", bgcolor: "#DDDDCC" }}
                >
                  {UIHelper.render_Content("Item Two", 10)}
                </Container>
              </TabPage>

              {/* Tab範例: Detail表單型 - 含卷軸 (blue) */}
              <TabPage
                tab_key={"Tab3"}
                curr_tab={AppBarTabIndex}
                sx={{ bgcolor: "#CCCCFF" }}
              >
                <Container maxWidth={MAX_WIDTH} sx={{ bgcolor: "#AAAAEE" }}>
                  {UIHelper.render_Content("Item Three", 30)}
                </Container>
              </TabPage>
            </Box>
          </Grid>
        </Grid>
      </>
    );
  }

  function render_AppBar() {
    return (
      <>
        <AppBar position="static" sx={{ bgcolor: R.color.app_bar }}>
          <Toolbar variant="dense">
            <AppMenuButton label={render_AppTitle()} />
            <Box sx={{ flexGrow: 1 }}>{/* 填滿 ActionBar 剩餘空間 */}</Box>
            {render_ActionButtons()}
          </Toolbar>
        </AppBar>
      </>
    );
  }

  function render_AppTitle() {
    return <Title variant="subtitle2">{"問卷場次列表"}</Title>;
  }

  function render_ActionButtons() {
    return (
      <div>
        <IconButton
          onClick={(e) => OnMenuOpen(e, "Menu更多")}
          size={"small"}
          edge="start"
          color="inherit"
          sx={{ ...sx_icon_button }}
        >
          {render_Menu更多("Menu更多")}
          <MoreIcon />
        </IconButton>
      </div>
    );
  }

  function render_DataGrid() {
    return (
      <DataGrid
        filterModel={filterModel}
        onFilterModelChange={handleFilterChange}
        components={{
          Toolbar: () => {
            return (
              <UcDgvCustomToolbar>
                <IconButton
                  onClick={() => {
                    Toast.Show(ctx, "More");
                  }}
                >
                  <MoreVertIcon />
                </IconButton>
              </UcDgvCustomToolbar>
            );
          },
          Pagination: () => {
            return <UcDgvCustomPagination />;
          },
        }}
        localeText={DGV_LOCAL_TEXT} // 中文
        style={{ width: "100%", backgroundColor: "white", padding: "12px" }}
        getRowId={(data) => {
          return data.guid;
        }}
        rows={_ProjectList ?? []}
        columns={grid_api.columns}
        pageSize={100}
        rowsPerPageOptions={[100]}
        onRowDoubleClick={(params) => {
          ctx.Navigate(ROUTE_project_editor.url + "?project=" + params.id);
          Toast.Show(ctx, "專案: " + params.id);
        }}
      />
    );
  }

  async function 合併場次_Click(project: Project) {
    let project_name = "";

    InputDialog.Show(ctx, "", "請輸入共用場次名稱", project.project_name, {
      async onDialogResult(e) {
        if (e.DialogResult === "Yes") {
          try {
            project_name = e.Data;
            let data: Project = new Project();
            data = {
              guid: data.guid,
              cid: project.cid,
              quest_start: project.quest_start,
              quest_end: project.quest_end,
              project_code: `#${project.project_code}`,
              project_name: `(共用設定)${
                project_name !== "" ? project_name : project.project_name
              }`,
              rec_dt: project.rec_dt,

              cust_code: project.cust_code,
              cust_name:
                project_name !== "" ? project_name : project.project_name,
              account_rule: project.account_rule,
              password_rule: project.password_rule,
              end_dt: project.end_dt,
              common_date: project.common_date,
              yup_pass: project.yup_pass,
            } as Project;
            await ProjectDAO.Insert(data);

            ctx.Navigate(ROUTE_project_merge.url + "?project=" + data.guid);
          } catch (ex: any) {
            Toast.ShowDanger(ctx, `543074 ${ex.message}`);
          }
        }
      },
    });
  }

  async function 取得基底場次() {
    const Now = DateHelper.取得當前時間();
    const str_dt = DateHelper.當前時間前後(Now, -6, "month");
    const end_dt = DateHelper.當前時間前後(Now, 6, "month");
    const project_list: Project[] = await ProjectDAO.Select指定日期(
      str_dt,
      end_dt
    );

    SelectDialog.Show(
      ctx,
      "選擇基底場次",
      "請選擇基底場次",
      "400px",
      project_list,
      "guid",
      "project_name",
      {
        async onDialogResult(x) {
          if (x.DialogResult === "Yes") {
            try {
              const project = x.Data as Project;
              合併場次_Click(project);
            } catch (ex: any) {
              Toast.ShowDanger(ctx, ex.message);
            }
          } else {
            Toast.Show(ctx, "未選擇基底場次");
          }
        },
      }
    );
  }
  function render_Menu更多(menu_name: string) {
    return (
      <Menu
        open={!!MenuPosition && MenuName === menu_name}
        onClose={() => set_MenuPosition(null)}
        anchorReference="anchorPosition"
        anchorPosition={MenuPosition}
      >
        <MenuItem
          onClick={() => {
            InputDialog.Show(ctx, "", "請輸入驗證碼", "", {
              async onDialogResult(e) {
                if (e.DialogResult === "Yes") {
                  if (e.Data === "5229") {
                    取得基底場次();
                  } else {
                    Toast.Show(ctx, "驗證失敗!");
                  }
                }
              },
            });
          }}
          sx={{ minWidth: "200px" }}
        >
          <ListItemText>合併場次</ListItemText>
        </MenuItem>
      </Menu>
    );
  }
};

export default FrmProjectList;
